import Draggable from "react-draggable";
import { useKeyFobAllocationModal } from "./index.hook";
import Loading from "../../common/Loading";
import { Button, Col, Form, Input, Modal, Row, Select } from "antd";
import styles from "../index.module.less";
import { useReactDraggable } from "../../../hooks/useReactDraggable";
import { formItemLayout, inputLayout2 } from "../../../constants/ApplicationConstants/FormConstants";
import FormInputRules from "../../../util/FormInputRules";
import { General } from "../../../util/General";
import CircularProgressBar from "../../common/CircularProgressBar";

import type { FormattedABRRequest } from "../../../shared/interface/advanceBookingRequest";

type KeyFobAllocationModalType = {
  data: FormattedABRRequest | null;
  handleOnClose: () => void | undefined;
  handleRefreshList: () => void;
  isModalVisible: boolean;
};

const KeyFobAllocationModal = (props: KeyFobAllocationModalType) => {
  const config = useKeyFobAllocationModal(props);

  const { bounds, onStart } = useReactDraggable();

  return (
    <Modal
      afterClose={() => config.form.resetFields()}
      destroyOnClose={true}
      maskClosable={false}
      centered
      title={<div className="modal-container">{`Create KeyFob Allocation and Send Booking Request`}</div>}
      open={props.isModalVisible}
      onCancel={props.handleOnClose}
      width={"80%"}
      okButtonProps={{
        style: {
          display: "none"
        }
      }}
      cancelButtonProps={{ style: { display: "none" } }}
      modalRender={(modal) => (
        <Draggable bounds={bounds} handle=".ant-modal-header" onStart={(event, uiData) => onStart(event as any, uiData)}>
          {modal}
        </Draggable>
      )}
      footer={null}
    >
      {config.loading && <Loading />}

      {!config.loading && (
        <Form
          onValuesChange={(changedValues) => {
            const fieldName = Object.keys(changedValues)[0];
            config.form.validateFields([fieldName]);
          }}
          className={`${styles["formDiv"]} ${styles["formDivExtended"]}`}
          {...formItemLayout}
          form={config.form}
          validateTrigger="onBlur"
          colon={false}
          name="register"
          onFinish={config.handleFinish}
        >
          <Row gutter={24}>
            <Col span={12} xs={24} sm={24} md={24} lg={12}>
              <Form.Item {...inputLayout2} name="booking_id" label="ABR ID" required>
                <Input name="booking_id" disabled />
              </Form.Item>

              <Form.Item {...inputLayout2} name="key_fob_id" label="KeyFob Token" rules={[FormInputRules.requiredFieldSelectRule("key fob token")]}>
                <Select disabled={config?.isDisabled} className={`${styles["from-Item-selectDiv"]}`} showSearch listHeight={200} allowClear getPopupContainer={(trigger) => trigger.parentElement} filterOption={General.searchFilterOnSelect} placeholder="Select KeyFob token">
                  {config.keyFobList?.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item?.keyFob_vehicle_dimension}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item {...inputLayout2} name="vehicle_number" label="Vehicle Number" normalize={General.inputWhiteSpaceRemove} rules={[FormInputRules.requiredFieldInputRule("vehicle number"), FormInputRules.validateVehicleNumber]}>
                <Input name="vehicle_number" disabled={config?.isDisabled} />
              </Form.Item>
            </Col>

            <Col span={12} xs={24} sm={24} md={24} lg={12}>
              <Form.Item {...inputLayout2} name="mobile_number" label="Mobile Number" required>
                <Input disabled prefix={"+91"} name="mobile_number" defaultValue={config.mobileNumber ?? ""} />
              </Form.Item>

              <Form.Item {...inputLayout2} name="first_name" label="First name" required>
                <Input name="first_name" disabled />
              </Form.Item>

              <Form.Item {...inputLayout2} name="last_name" label="Last Name" required>
                <Input name="last_name" disabled />
              </Form.Item>
            </Col>
          </Row>

          <div className={styles.formFooter}>
            <Form.Item className={styles.formItemFloatR20}>
              <Button disabled={config.saving} className={`gx-mb-0 button-gradiant`} onClick={props.handleOnClose}>
                Close
              </Button>
            </Form.Item>

            <Form.Item className={styles.formItemFloatR20}>
              <Button className={`gx-mb-0 button-gradiant`} htmlType="submit">
                {config.saving ? <CircularProgressBar /> : "Submit & Send Booking Request"}
              </Button>
            </Form.Item>
          </div>
        </Form>
      )}
    </Modal>
  );
};

export default KeyFobAllocationModal;
